<template>
  <v-bottom-sheet
       v-model="sheet"
       scrollable
       persistent
       no-click-animation
       :overlay-opacity="0.7"
       content-class="bottom-sheet"
     >
     <v-card>
       <!-- <SheetHeader :title="'감정 찾기'" @sheetClose="$emit('sheetClose')"/> -->
       <SheetHeader :title="'감정 찾기'" @sheetClose="sheetClose()"/>
       <v-card-text  class="sheet-body pa-0">
         <!-- <Emotion :multiple="false" :maxSelect="1" :emotionStrArr="emotionStrArr" :maxHeight="`calc(calc(var(--vh, 1vh) * 100) - 300px)`" @changedToggle="changedToggle"/> -->
         <Emotion :multiple="true"
                  :maxSelect="maxSelect"
                  :emotionStrArr="emotionStrArr"
                  :maxHeight="`calc(calc(var(--vh, 1vh) * 100) - 320px)`"
                  :answer="answer"
                  @emotionChoice="emotionSelected"/>
       </v-card-text>
       <v-card-actions class="sheet-footer">
         <v-btn
           block
           height="48"
           depressed
           class="btn-primary"
           @click="$emit('close',emotionSelectList)"
         >
           선택 완료
         </v-btn>
       </v-card-actions>
     </v-card>
   </v-bottom-sheet>
 </template>
 <script>
 import SheetHeader from "./SheetHeader";
 import Emotion from '@/components/solution/Emotion'
 export default {
    props:{
        sheet:Boolean,
        emotionStrArr:Array,
        maxSelect:Number,
        answer:Array,
    },
   data: () =>({
     // selectEmotion: null,
    //  answer:[],
    //  emotionSelectList:[],
    //  emotionSelectParam:[],
   }),
   components:{
     SheetHeader,
     Emotion,
   },
   created () {

   },
   mounted(){
   },
   methods:{
      emotionSelected(emotionSelected){

        if(!this.cmplt){
          this.emotionSelectList = emotionSelected
        }
        this.$emit('emotionSelected',this.emotionSelectList)
     },
    //  changedToggle(value){
    //      this.selectEmotion = value;
    //  },
     sheetClose(){
        this.$emit('close')
     }
   },
 }
 </script>
